// src/components/AboutSection.js
import React from "react";
import { useNavigate } from "react-router-dom";
import aboutImg from "../Assessts/Aboutus8.png";
import "./AboutSection.css";

export default function AboutSection() {
  const navigate = useNavigate();

  return (
    <div className="about-section">
      <div className="about-image">
        <img src={aboutImg} alt="About Technocrat" />
      </div>
      <div className="about-text">
        <h2>
          <span className="highlight" style={{ color: "#074f86ff" }}>
            About Technocrat
          </span>
        </h2>
        <p>
          Technocrat Aerospace & Defence (TAAD) is an{" "}
          <strong>ISO 9001:2015</strong> and <strong>CE-certified</strong>{" "}
          manufacturer, system integrator, and service provider delivering{" "}
          high-performance solutions for{" "}
          <strong>Aerospace, Aviation, Defence, Railways,</strong> and{" "}
          <strong>Scientific Research</strong> applications, with operations rooted in India and engagements across leading{" "}
          public and private sector programs.
          <br />
         Technocrat Aerospace & Defence (TAAD) proudly
          identifies as a <strong>Proudly Made in India</strong> company, fully
          committed to indigenous development and manufacturing{" "}
          in alignment with the vision of{" "}
          <strong>Atmanirbhar Bharat</strong> — a{" "}
          self-reliant India. This vision emphasizes{" "}
          designing, developing, and producing cutting-edge aerospace and defense technologies{" "}
          domestically. Leveraging <strong>advanced engineering excellence</strong> and{" "}
          <strong>industry expertise</strong>, TAAD delivers mission-critical
          products including <strong>DAQ systems</strong>,{" "}
          <strong>RF and microwave modules</strong>,{" "}
          <strong>rugged embedded computing</strong>,{" "}
          <strong>avionics interfaces</strong>, <strong>sensors</strong>, and{" "}
          <strong>PCB assemblies</strong> that meet global standards while being{" "}
          manufactured locally.
        </p>
        <p>
          This indigenous manufacturing approach enables the
          nation to enhance <strong>strategic autonomy</strong>, reduce{" "}
         dependency on imports, and contribute to the rapidly
          evolving global technology landscape from a position
          of <strong>strength and security</strong>. TAAD’s dedication to{" "}
          Indian ingenuityand{" "}
          resourcefulness exemplifies the broader national
          drive towards self-reliance in aerospace and defense manufacturing, 
          supported by <strong>government initiatives</strong> and growing{" "}
          industry capabilities.
        </p>

        <button onClick={() => navigate("/about")} className="read-more-btn">
          Read More
        </button>
      </div>
    </div>
  );
}
